import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';
import { HelperService } from '@services/helper/helper.service';


@Pipe({
    name: 'contentOpeningHours',
    standalone: false
})
export class OpeningHoursPipe implements PipeTransform {
  weekDay = { 0: 'sunday', 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday' };
  private today = new Date();

  constructor(
    private contentPipeService: ContentPipeService
  ) {
  }

  transform(entry: any): any {
    if (!entry || !entry.content) {
      return null;
    }

    const openingHoursEntry: any = new Models.ContentOpeningHours();

    let data = entry.content.openingHours;
    let showInWidget = entry && entry.content && entry.content.showInWidget ? entry.content.showInWidget : null;
    let raw;
    if (entry.content.raw) {
      try {
        raw = JSON.parse(entry.content.raw);
        showInWidget = !!raw.showInWidget ? raw.showInWidget : showInWidget;
        data = !data ? raw.openingHours : data;
      } catch (err) {}
    }
    if (!data && (!entry.detail.openingInfo && !raw.openingInfo)) {
      return null;
    }
    if (!!data) {
      openingHoursEntry.openingHours = {
        exceptionDays: data.exceptionDays ? data.exceptionDays : [],
        regularOpeningHours: data.regularOpeningHours ? data.regularOpeningHours : null,
      };

      for (let i = 0; i < openingHoursEntry.openingHours.exceptionDays.length; i++) {
        for (let t = 0; t < openingHoursEntry.openingHours.exceptionDays[i].times.length; t++) {
          if (openingHoursEntry.openingHours.exceptionDays[i].opened || openingHoursEntry.openingHours.exceptionDays[i].open) {
            const time = openingHoursEntry.openingHours.exceptionDays[i].times[t];
            time.startTime = this.fixTime(time.startTime);
            time.endTime = this.fixTime(time.endTime);
            if (!time.startTime?.length && !time.startTime?.length) {
              openingHoursEntry.openingHours.exceptionDays[i].times.splice(t, 1);
            } else {
              openingHoursEntry.openingHours.exceptionDays[i].times[t] = time;
            }
          }
        }
      }
      if (openingHoursEntry?.openingHours?.regularOpeningHours) {
        for (const key of Object.keys(openingHoursEntry.openingHours.regularOpeningHours)) {
          for (let t = 0; t < openingHoursEntry.openingHours.regularOpeningHours[key].times.length || 0; t++) {
            if (openingHoursEntry.openingHours.regularOpeningHours[key].opened || openingHoursEntry.openingHours.regularOpeningHours[key].open) {
              const time = openingHoursEntry.openingHours.regularOpeningHours[key].times[t];
              time.startTime = this.fixTime(time.startTime);
              time.endTime = this.fixTime(time.endTime);
              if (!time.startTime?.length && !time.startTime?.length) {
                openingHoursEntry.openingHours.regularOpeningHours[key].times.splice(t, 1);
              } else {
                openingHoursEntry.openingHours.regularOpeningHours[key].times[t] = time;
              }
            }
          }
        }
      }
    } else {
      openingHoursEntry.openingHours = HelperService.initOpeningData(entry.detail.openingInfo ? entry.detail : raw);
    }

    openingHoursEntry.populateFromJSON({
      textContent: entry && entry.content && entry.content.textContent ? entry.content.textContent : null, showInWidget
    });

    openingHoursEntry.title = entry.title;
    openingHoursEntry.sourceId = entry._id;
    openingHoursEntry.media = this.contentPipeService.getMedia(entry);
    openingHoursEntry.openingHours = HelperService.initOpeningData(entry.content) || openingHoursEntry.openingHours;
    openingHoursEntry.contentType = 'opening-hours';
    return this.formatData(openingHoursEntry);
  }

  fixTime(time: string): string {
    if (!time) {
      return time;
    }
    const postMeridian = !!time.indexOf('pm') && !time.startsWith('12');
    time = time?.replace(/[^\d:.]/gm, '').replace(/\./, ':');
    if (!time?.includes(':')) {
      time = this.floatToStringTime(parseFloat(time) / 100);
    }
    if (postMeridian) {
      time = this.floatToStringTime(parseFloat(time.replace(':', '')) / 100 + 12);
    }
    return time;
  }

  floatToStringTime(floatTime) {
    try {
      const tempTime = floatTime.toString().split('.');
      if (tempTime[0].length < 2) {
        tempTime[0] = '0' + tempTime[0];
      }
      if (!tempTime[1]) {
        tempTime[1] = '00';
      } else if (tempTime[1].length === 1) {
        tempTime[1] = tempTime[1] + '0';
      }
      floatTime = tempTime.join('.');
      return floatTime;
    } catch (err) {
      return floatTime;
    }
  }

  formatData(openingHoursEntry) {
    const todayDay = this.today.getDay();
    const todayHours = this.today.getHours();
    if (openingHoursEntry?.openingHours?.exceptionDays) {
      openingHoursEntry = this.checkExceptionDays(openingHoursEntry);
    }
    if (!openingHoursEntry?.openingHours?.regularOpeningHours || !openingHoursEntry?.openingHours?.regularOpeningHours[this.weekDay[todayDay]]) {
      openingHoursEntry.opened = false;
    } else {
      openingHoursEntry.opened = openingHoursEntry?.openingHours?.regularOpeningHours[this.weekDay[todayDay]].open;
    }
    if (openingHoursEntry.opened) {
      const times = openingHoursEntry?.openingHours?.regularOpeningHours[this.weekDay[todayDay]].times;
      for (let t = 0; t < times.length; t++) {
        // check if time is before working hours
        const startDate = new Date() as any;
        const endDate = new Date() as any;
        startDate.setHours(+times[t].startTime.split(':')[0]);
        startDate.setMinutes(+times[t].startTime.split(':')[1]);
        startDate.setSeconds(0);
        endDate.setHours(+times[t].endTime.split(':')[0]);
        endDate.setMinutes(+times[t].endTime.split(':')[1]);
        endDate.setSeconds(59);
        if (endDate < startDate) {
          endDate.setDate(endDate.getDate() + 1);
        }
        if (t === 0 && this.today < startDate) {
          openingHoursEntry.opened = false;
          openingHoursEntry.time = times[t].startTime;
          break;
        }
        //
        if ((this.today > startDate) && (this.today < endDate)) {
          openingHoursEntry.opened = true;
          openingHoursEntry.time = times[t].endTime;
          break;
        } else {
          openingHoursEntry.opened = false;
          if (t !== times.length - 1) {
            if (+todayHours > +times[t].endTime.split(':')[0] && +todayHours < +times[t + 1].startTime.split(':')[0]) {
              openingHoursEntry.time = times[t + 1].startTime;
              break;
            }
          }
          if (t === times.length - 1) {
            openingHoursEntry = this.findNextDay(openingHoursEntry);
          }
        }
      }
    } else {
      openingHoursEntry = this.findNextDay(openingHoursEntry);
    }
    return openingHoursEntry;
  }

  findNextDay(openingHoursEntry) {
    let d = 1;
    while (d < 7) {
      const nextDay = new Date(this.today);
      nextDay.setDate(nextDay.getDate() + d);
      if (
        openingHoursEntry?.openingHours?.regularOpeningHours &&
        openingHoursEntry.openingHours.regularOpeningHours[this.weekDay[nextDay.getDay()]] &&
        openingHoursEntry.openingHours.regularOpeningHours[this.weekDay[nextDay.getDay()]].open &&
        openingHoursEntry.openingHours.regularOpeningHours[this.weekDay[nextDay.getDay()]].times &&
        openingHoursEntry.openingHours.regularOpeningHours[this.weekDay[nextDay.getDay()]].times.length
      ) {
        openingHoursEntry.day = this.weekDay[nextDay.getDay()];
        openingHoursEntry.time = openingHoursEntry.openingHours.regularOpeningHours[this.weekDay[nextDay.getDay()]].times[0].startTime;
        if (d === 1) {
          openingHoursEntry.isTomorrow = true;
        }
        break;
      }
      d++;
    }
    return openingHoursEntry;
  }

  checkExceptionDays(openingHours) {
    if (openingHours.openingHours.exceptionDays && openingHours.openingHours.exceptionDays.length) {
      for (let i = 0; i < openingHours.openingHours.exceptionDays.length; i++) {
        const date = new Date(openingHours.openingHours.exceptionDays[i].date);
        const todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);
        if (date.getTime() === todayDate.getTime()) {
          const todayDay = this.today.getDay();
          openingHours.openingHours.regularOpeningHours[this.weekDay[todayDay]].times = openingHours.openingHours.exceptionDays[i].times;
          openingHours.openingHours.regularOpeningHours[this.weekDay[todayDay]].open = openingHours.openingHours.exceptionDays[i].open;
          openingHours.exceptionDay = openingHours.openingHours.exceptionDays[i].title;
        }
      }
    }
    return openingHours;
  }

}
